import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_DIGITAL_OFFERS, GET_DIGITAL_OFFERS_ERROR, GET_DIGITAL_OFFERS_SUCCESS } from '../../actions.js';

function* getDigitalOffers() {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/benefit-type/digital/offers`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_DIGITAL_OFFERS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_DIGITAL_OFFERS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_DIGITAL_OFFERS_ERROR, payload: error });
  }
}

export function* watchGetDigitalOffers() {
  yield takeEvery(GET_DIGITAL_OFFERS, getDigitalOffers);
}

function* getDigitalOffersSaga() {
  yield all([fork(watchGetDigitalOffers)]);
}

export default getDigitalOffersSaga;
